import { useEffect } from "react";
import { useAuth0, type User } from "@auth0/auth0-react";
import { config } from "config";
import { useUserRoles } from "contexts/UserRoles";
import { USERID_CLAIMS } from "system-constants";
import { addRumSessionAttributes, initRum } from "shared/rum/rumClient";

function readUserId(user: User | undefined): string | undefined {
  const claim = user?.[USERID_CLAIMS];

  return typeof claim === "string" && claim !== "" ? claim : undefined;
}

export function useRumIdentity(): void {
  const { user } = useAuth0();
  const { roles } = useUserRoles();
  const userId = readUserId(user);
  const email = user?.email ?? "";
  const rolesText = roles.join(", ");

  useEffect(() => {
    if (userId === undefined) {
      return;
    }

    initRum(config, userId);
    addRumSessionAttributes({ email, roles: rolesText });
  }, [userId, email, rolesText]);
}
